import {SortOrder} from '@netx/core-schema';

export const sortByTime = (
	a: number,
	b: number,
	order: SortOrder = SortOrder.ASCENDING,
) => (a - b) * (order === SortOrder.ASCENDING ? 1 : -1);
